<template>
  <div class="position-relative pb-5">
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <!-- {{ this.$store.state.auth }} -->
    <div class="row mb-5">
      <ul class="nav nav-tabs nav-fill">
        <li class="nav-item">
          <button
            type="button"
            :class="tab_switch('club')"
            @click="tab_switch_action('club')"
          >
            <i class="bi bi-person-fill me-1"></i>公認クラブ情報
          </button>
        </li>
        <li class="nav-item">
          <button
            type="button"
            :class="tab_switch('member')"
            @click="tab_switch_action('member')"
          >
            <i class="bi bi-person-fill me-1"></i>クラブ員情報
          </button>
        </li>
        <!-- <li class="nav-item" v-if="not_add">
          <button type="button" :class="tab_switch('license')" @click="tab_switch_action('license')" >
            <i class="bi bi-list-check me-1"></i>ライセンス情報
          </button>
        </li>
        <li class="nav-item d-none" v-if="not_add">
          <button type="button" :class="tab_switch('pre_ex')" @click="tab_switch_action('pre_ex')" >
            <i class="bi bi-file-earmark-medical"></i>エントリー履歴
          </button>
        </li> -->
      </ul>
    </div>
    <div :class="'w100 ' + tabDisplay('member')">
      <h5>クラブ員情報</h5>
      <div class="container">
        <div class="row mb-2 py-2">
          <div class="col-2 text-end">参加年度で検索</div>
          <div class="col-2">
            <bs-select
              :options="m_relation_list_year_list"
              :nullOption="true"
              v-model="member_sel_year"
            ></bs-select>
          </div>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center">ライセンスNo</th>
              <th class="text-center">会員氏名</th>
              <th class="text-center">状況</th>
              <th class="text-center">生年月日(和暦)</th>
              <th class="text-center">参加年度</th>
              <th class="text-center">更新年</th>
              <th class="text-center w-25">ライセンス</th>
              <th v-if="!change_mode" class="text-center">削除</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rel in m_relation_list_year" :key="rel">
              <td class="text-center">{{ (rel || {}).license_no }}</td>
              <td class="text-center">
                {{ ((rel || {}).m_data || {}).name_label }}
              </td>
              <td class="text-center">
                <span v-if="(rel || {}).stat == 9" class="text-danger"
                  >削除予定</span
                >
                <span
                  v-else-if="
                    (rel || {}).stat_d == 0 && (rel || {}).reject_flg == 0
                  "
                  >未承認</span
                >
                <span
                  v-else-if="
                    (rel || {}).stat_d == 0 && (rel || {}).reject_flg == 1
                  "
                  >拒否</span
                >
                <span v-else-if="(rel || {}).stat_d == 1">承認</span>
              </td>
              <td class="text-center">
                {{ ((rel || {}).m_data || {}).birth_date }} ({{
                  get_wareki(((rel || {}).m_data || {}).birth_date)
                }})
              </td>
              <td class="text-center">
                {{ (rel || {}).license_year }}
              </td>
              <td class="text-center">
                {{ ((rel || {}).m_data || {}).last_sports_year }}
              </td>
              <td class="text-center">
                <span
                  class="badge bg-secondary me-2"
                  v-for="license in (
                    (rel || {}).m_data || {}
                  ).member_license.filter(
                    lc => lc.license_year == (rel || {}).license_year
                  )"
                  :key="license.id"
                >
                  {{ license.license_label }}
                </span>
              </td>
              <td class="text-center" v-if="!change_mode">
                <button
                  type="button"
                  @click="toggle_del_sw(rel.id, true)"
                  class="btn btn-sm btn-light btn-outline-secondary"
                  v-if="(rel || {}).stat != 9"
                >
                  <i class="bi bi-square"></i>
                </button>
                <button
                  type="button"
                  @click="toggle_del_sw(rel.id, false)"
                  class="btn btn-sm btn-warning"
                  v-else
                >
                  <i class="bi bi-check-square"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        {{ dev_msg('ライセンス等、申請処理実装後に表示される予定') }}
      </div>
    </div>
    <div :class="'w100 ' + tabDisplay('club')">
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">登録情報</p>
        </div>
      </div>
      <div class="container">
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">年度</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                id="last_sports_year"
                placeholder="年度"
                :value="get_last_event_year"
                :disabled="input_readonly"
              />
              <span class="input-group-text">年度</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">クラブコード</p>
          </div>
          <div class="col-3">
            <input
              type="text"
              :class="not_add ? input_class_f : input_class"
              placeholder="クラブコード"
              v-model="club_obj.club_no"
              :readonly="input_readonly_f"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインID</p>
          </div>
          <div class="col-6">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="ログインID"
                v-model="club_obj.login_id"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="ログインID"
                v-model="club_obj.login_id"
              />
            </div>
            <div v-if="chk_error('login_id')" class="text-danger">
              {{ get_error_msg('login_id') }}
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="!change_mode && !not_add">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ログインPW</p>
          </div>
          <div :class="pass_chg_sw ? 'col-10' : 'col-4'">
            <div class="input-group">
              <label class="input-group-text" for="PassChgSw">
                <input
                  class="form-check-input mt-0 me-2"
                  id="PassChgSw"
                  type="checkbox"
                  v-model="pass_chg_sw"
                />
                変更
              </label>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード"
                v-model="login_pass_input"
                :disabled="!pass_chg_sw ? 'disabled' : false"
              />
              <span class="input-group-text" v-if="pass_chg_sw">確認用</span>
              <input
                type="text"
                :class="input_class"
                placeholder="パスワード確認用"
                v-model="pass_chg_confirm"
                v-if="pass_chg_sw"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">登録日付</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="登録日付"
                v-model="club_obj.cre_date_date"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="登録日付"
                v-model="club_obj.cre_date_date"
              />
            </div>
          </div>
          <div class="col-2">
            <p class="text-center py-1 fs-7">更新日</p>
          </div>
          <div class="col-3">
            <div class="input-group">
              <input
                v-if="change_mode"
                type="text"
                :class="input_class"
                placeholder="更新日"
                v-model="club_obj.up_date_date"
                :disabled="input_readonly"
              />
              <input
                v-else
                type="text"
                :class="chk_input_class('login_id', 'input')"
                placeholder="更新日"
                v-model="club_obj.up_date_date"
              />
            </div>
          </div>
        </div>
        <div class="row mb-1 pb-1 border-bottom">
          <div class="col-2">
            <p class="fs-6 mb-0 pb-0">名称</p>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">クラブ名</p>
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class"
              id="Name_1"
              placeholder="クラブ名"
              v-model="club_obj.name_1"
              :disabled="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">カナ</p>
          </div>
          <div class="col-6">
            <input
              type="text"
              :class="input_class"
              id="Yomi_1"
              placeholder="セイ"
              v-model="club_obj.yomi_1"
              :disabled="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">責任者</p>
          </div>
          <div class="col-5">
            <div class="input-group">
              <span class="input-group-text">姓</span>
              <input
                type="text"
                :class="input_class"
                id="Name_2"
                placeholder="姓"
                v-model="club_obj.name_2"
                :disabled="input_readonly"
              />
            </div>
          </div>
          <div class="col-5">
            <div class="input-group">
              <span class="input-group-text">名</span>
              <input
                type="text"
                :class="input_class"
                id="Name_3"
                placeholder="名"
                v-model="club_obj.name_3"
                :disabled="input_readonly"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">責任者(カナ)</p>
          </div>
          <div class="col-5">
            <div class="input-group">
              <span class="input-group-text">セイ</span>
              <input
                type="text"
                :class="input_class"
                id="Yomi_2"
                placeholder="セイ"
                v-model="club_obj.yomi_2"
                :disabled="input_readonly"
              />
            </div>
          </div>
          <div class="col-5">
            <div class="input-group">
              <span class="input-group-text">名</span>
              <input
                type="text"
                :class="input_class"
                id="Yomi_3"
                placeholder="メイ"
                v-model="club_obj.yomi_3"
                :disabled="input_readonly"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3 d-none">
          <div class="col-2">
            <p class="text-center py-1 fs-7">写真</p>
          </div>
          <div class="col-3">
            <div class="w-100" v-if="typeof get_assets(100, 0) === 'object'">
              <img :src="(get_assets(100, 0) || {}).path" class="w-100" />
            </div>
          </div>
          <div class="col-6">
            <input
              type="file"
              v-if="!change_mode"
              :class="input_class"
              id="file_up_input_100"
              @change="selectedFile($event, 100)"
            />
          </div>
        </div>
      </div>
      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">住所・連絡先</p>
        </div>
      </div>
      <div
        class="container"
        v-for="(prof, index) in club_obj.profile"
        :key="prof"
      >
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">郵便番号</p>
          </div>
          <div class="col-4">
            <div class="input-group">
              <input
                type="text"
                :class="input_class"
                placeholder="郵便番号"
                v-model="prof.postal_cd"
                :readonly="input_readonly"
              />
              <button
                v-if="!change_mode"
                type="button"
                class="btn btn-light btn-outline-secondary"
                @click="get_address(prof.postal_cd, index)"
              >
                郵便番号検索
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">都道府県</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              type="text"
              :class="input_class"
              :readonly="input_readonly"
              :value="get_pref_label(prof.pref_cd)"
            />
            <bs-select
              v-else
              :options="pref_list"
              :nullOption="true"
              id="SexType"
              v-model="prof.pref_cd"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">市区町村・番地</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="市区町村・番地"
              v-model="prof.address_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">建物名・室号</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="建物名・室号"
              v-model="prof.address_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号1</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="prof.tel_1[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_1[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_1[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号1"
              v-model="prof.tel_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">連絡先電話番号2</p>
          </div>
          <div class="col-5">
            <!-- <div class="input-group">
                <input type="text" v-model="prof.tel_2[0]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_2[1]" :class="input_class" :readonly="input_readonly">
                <span class="input-group-text">-</span>
                <input type="text" v-model="prof.tel_2[2]" :class="input_class" :readonly="input_readonly">
            </div> -->
            <input
              type="text"
              :class="input_class"
              placeholder="連絡先電話番号2"
              v-model="prof.tel_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス1</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス1"
              v-model="prof.mail_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールアドレス2</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="メールアドレス2"
              v-model="prof.mail_2"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2">
            <p class="text-center py-1 fs-7">ホームページ</p>
          </div>
          <div class="col-10">
            <input
              type="text"
              :class="input_class"
              placeholder="ホームページ"
              v-model="prof.website_url_1"
              :readonly="input_readonly"
            />
          </div>
        </div>
        <div class="row mb-3 d-none">
          <div class="col-2">
            <p class="text-center py-1 fs-7">メールマガジン配信希望</p>
          </div>
          <div class="col-4">
            <input
              v-if="change_mode"
              :value="get_request_cd_label(prof.mail_flg)"
              :class="input_class"
              :readonly="input_readonly"
            />
            <bs-select
              v-else
              :options="request_type_list"
              :nullOption="true"
              v-model="prof.mail_flg"
            ></bs-select>
          </div>
        </div>
      </div>

      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">活動種目</p>
        </div>
        <div class="col-10 offset-1 offset-lg-0 col-lg-10">
          <div class="row">
            <div
              class="col-6 col-md-3 col-lg-3 mb-2"
              v-for="event in event_cd_list"
              :key="event"
            >
              <div class="d-grid">
                <span
                  v-if="change_mode"
                  :class="event_class(event.id)"
                  disabled="disabled"
                >
                  <i :class="event_class_icon(event.id)"></i>&nbsp;
                  {{ event.label }}
                </span>
                <button
                  v-else
                  :class="event_class(event.id)"
                  @click="toggleEvent(event.id)"
                >
                  <i :class="event_class_icon(event.id)"></i>&nbsp;
                  {{ event.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-1 pb-1 border-bottom">
        <div class="col-2">
          <p class="fs-6 mb-0 pb-0">その他</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-2">
          <p class="text-center py-1 fs-7">対応メモ</p>
          <div v-if="!change_mode">
            <button
              type="button"
              class="btn btn-light btn-outline-secondary"
              @click="add_note"
            >
              <i class="bi bi-plus"></i>
            </button>
          </div>
        </div>
        <div class="col-10">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20%">日時</th>
                <th style="width: auto">メモ</th>
                <th style="width: 20%">記入者</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="note in club_obj.club_note" :key="note">
                <td>
                  <input
                    type="date"
                    v-model="note.set_date"
                    class="form-control form-control-sm"
                    :disabled="note.id > 0 ? 'disabled' : false"
                  />
                </td>
                <td>
                  <textarea
                    class="form-control form-control-sm"
                    v-model="note.body"
                    :disabled="note.id > 0 ? 'disabled' : false"
                  ></textarea>
                </td>
                <td>
                  <input
                    type="text"
                    v-model="note.manage_label"
                    class="form-control form-control-sm"
                    disabled="disabled"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="mb-5"></div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
    >
      <div class="row">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            v-if="change_mode"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
          <button
            type="submit"
            v-else-if="not_add"
            @click="toggle_change_mode"
            class="btn btn-light btn-outline-secondary"
          >
            照会画面へ戻る
          </button>
          <button
            type="submit"
            v-else-if="!not_add"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/club/data')"
        >
          <bs-button
            v-if="change_mode"
            :btnClass="'btn-primary'"
            @to_click_event="toggle_change_mode"
            >編集へ</bs-button
          >
          <bs-button
            v-else
            :btnClass="'btn-primary'"
            @to_click_event="update_club"
            >{{ btnLabel }}</bs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.fs-6 {
  font-size: 1.15rem !important;
}
.fs-7 {
  font-size: 1rem !important;
}
.fs-8 {
  font-size: 0.9rem !important;
}
.input-group > .form-control-plaintext {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  padding: 0.375rem;
  border-bottom: solid 1px #999;
}
.form-control-plaintext {
  border-bottom: solid 1px #999;
}
</style>
<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'
import common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'

export default {
  name: 'ClubDetailView',
  data: function () {
    return {
      superuser_sw: this.$store.state.auth.userId == 1 ? false : false,
      targetid: this.$route.params.id,
      change_mode: true,
      change_mode_0: true,
      fromParentTitle: '',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      club_obj: {},
      club_error_obj: {},
      pref_obj: [],
      request_type_cd_obj: [],
      identify_type_cd_obj: [],
      exclude_cd_obj: [],
      dead_or_live_obj: [],
      club_assets_cd_obj: [],
      club_document_cd_obj: [],
      continue_app_type_obj: [],
      continue_data_save_type_obj: [],
      affiliation_type_obj: [],
      belong_club_status_obj: [],
      insurance_type_obj: [],
      member_sel_year: '',
      event_cd_obj: [],
      event_relation_obj: [],
      event_form_obj: {
        id: 0,
        stat: 1,
        c_id: this.targetid,
        event_id: 0,
        event_cd: ''
      },
      m_relation_obj: [],

      license_type_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      // event_cd_obj: [],
      license_cd_obj: [],
      personal_type_obj: [],
      circuit_obj: [],
      tab_active: 'club',
      pass_chg_sw: false,
      login_pass_input: '',
      pass_chg_confirm: '',
      // subsub_category_obj: [],
      // require_list: config.REQUIRE_TYPE_LIST,
      profile_column: {
        id: 0,
        postal_cd: '',
        pref_cd: '',
        address_1: '',
        address_2: '',
        address_3: '',
        tel_1: '',
        tel_2: '',
        mail_1: '',
        mail_2: '',
        mail_flg: ''
      },
      insurance_column: {
        id: 0,
        insurance_type: '',
        sports_year: '',
        start_date: '',
        end_date: ''
      },
      circuit_license_column: {
        id: 0,
        circuit_id: '',
        circuit_license_no: ''
      },
      belong_club_column: {
        id: 0,
        group_id: ''
      },
      system_exclude_column: {
        id: 0,
        exclude_cd: '',
        start_date: '',
        start_date_date: '',
        end_date: '',
        end_date_date: '',
        note: '',
        manage_id: this.$store.state.auth.userId,
        manage_label: this.$store.state.auth.label
      },
      club_parent_column: {
        id: 0,
        license_no: '',
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        birth_date: '',
        sex_type: '',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        application_date: '',
        permission_date: '',
        application_date_date: '',
        permission_date_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_manage_id: '',
        permission_manage_label: '',
        permission_manage_sw: false
      },
      club_note_column: {
        id: 0,
        manage_id: '',
        manage_label: '',
        set_date: '',
        body: ''
      },
      club_assets_column: {
        id: 0,
        type: '',
        path: ''
      },
      club_license_column: {
        id: 0,
        license_cd: '',
        license_year: '',
        license_to_id: '',
        issue_date: ''
      },
      oParam: [
        'profile',
        'insurance',
        'circuit_license',
        'belong_club',
        'system_exclude',
        'club_parent'
        // 'club_note',
        // 'club_assets',
        // 'club_license'
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert,
    BsButton
  },
  methods: {
    async toggle_del_sw(target, flg) {
      const tmps = [...this.m_relation_obj]
      const index = tmps.find(obj => obj.id == target)
        ? tmps.findIndex(obj => obj.id == target)
        : false
      if (index !== false) {
        // tmps.splice(index, 1);
        tmps[index].stat = flg ? 9 : tmps[index].stat_d == 1 ? 1 : 0
      }
      this.m_relation_obj = tmps
      this.$forceUpdate()
    },
    async toggleEvent(event_id) {
      const tmps = [...this.event_relation_obj]
      if (this.event_relation_obj.find(obj => obj.event_id == event_id)) {
        const index = this.event_relation_obj.findIndex(
          obj => obj.event_id == event_id
        )
        tmps.splice(index, 1)
      } else {
        const tmp = { ...this.event_form_obj }
        tmp.event_id = event_id
        tmp.event_cd = this.event_cd_list.find(list => list.id == event_id)
          ? this.event_cd_list.find(list => list.id == event_id).event_cd
          : ''
        tmps.push(tmp)
      }
      this.event_relation_obj = tmps
    },
    async selectedFile(e, type_cd) {
      e.preventDefault()
      const files = [...e.target.files]
      // let ups = [];
      files.forEach(async file => {
        const form = new FormData()
        form.append('file', file)
        await this.basicPosts_R(
          config.BASE_API_URL + '/upload/club_assets',
          form
        )
          .then(res => {
            console.log(res)
            if (res && res.status == 200) {
              const asset_tmp = {
                id: 0,
                stat: 1,
                m_id: 0,
                type: 0,
                path: ''
              }
              const tmps =
                typeof this.club_obj.club_assets === 'object'
                  ? [...this.club_obj.club_assets]
                  : []
              const asset = tmps.find(tmp => tmp.type == type_cd)
                ? tmps.find(tmp => tmp.type == type_cd)
                : asset_tmp
              asset.m_id = this.not_add ? this.targetid : 0
              asset.type = type_cd
              asset.path = res.data.body.file_path
                ? res.data.body.file_path
                : ''

              if (tmps.find(tmp => tmp.id == asset.id)) {
                const fIndex = tmps.findIndex(tmp => tmp.id == asset.id)
                tmps[fIndex] = asset
                this.club_obj.club_assets = tmps
              } else {
                this.club_obj.club_assets = [asset].concat(tmps)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            document.getElementById('file_up_input_' + type_cd).value = ''
          })
      })
    },
    async add_circuit_license() {
      const tmps = { ...this.circuit_license_column }
      const circuit_license =
        typeof this.club_obj.circuit_license === 'object'
          ? this.club_obj.circuit_license
          : []
      circuit_license.push(tmps)
      this.club_obj.circuit_license = circuit_license
    },
    async add_belong_club() {
      const tmps = { ...this.belong_club_column }
      const belong_club =
        typeof this.club_obj.belong_club === 'object'
          ? this.club_obj.belong_club
          : []
      belong_club.push(tmps)
      this.club_obj.belong_club = belong_club
    },
    async add_system_exclude() {
      const tmps = { ...this.system_exclude_column }
      const system_exclude =
        typeof this.club_obj.system_exclude === 'object'
          ? this.club_obj.system_exclude
          : []
      system_exclude.push(tmps)
      this.club_obj.system_exclude = system_exclude
    },
    async del_system_exclude(index) {
      const system_exclude =
        typeof this.club_obj.system_exclude === 'object'
          ? this.club_obj.system_exclude
          : []
      system_exclude.splice(index, 1)
      this.club_obj.system_exclude = system_exclude
    },
    async add_note() {
      const tmps = { ...this.club_note_column }
      tmps.set_date = common.getToday()
      tmps.manage_id = this.$store.state.auth.userId
      tmps.manage_label = this.$store.state.auth.label
      const notes =
        typeof this.club_obj.club_note === 'object'
          ? this.club_obj.club_note
          : []
      notes.push(tmps)
      this.club_obj.club_note = notes
    },
    async set_club_identify() {
      this.club_obj.identify_manage_id = this.$store.state.auth.userId
      this.club_obj.identify_date_date = common.getToday()
      this.club_obj.identify_manage_label = this.$store.state.auth.label
    },
    async clear_club_identify() {
      this.club_obj.identify_manage_id = 0
      this.club_obj.identify_date_date = ''
      this.club_obj.identify_manage_label = ''
    },
    async set_club_permission() {
      this.club_obj.permission_manage_id = this.$store.state.auth.userId
      this.club_obj.permission_date_date = common.getToday()
      this.club_obj.permission_manage_label = this.$store.state.auth.label
    },
    async clear_club_permission() {
      this.club_obj.permission_manage_id = 0
      this.club_obj.permission_date_date = ''
      this.club_obj.permission_manage_label = ''
    },
    async set_parent_identify(index) {
      this.club_obj.club_parent[index].identify_manage_id =
        this.$store.state.auth.userId
      this.club_obj.club_parent[index].identify_date_date = common.getToday()
      this.club_obj.club_parent[index].identify_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_identify(index) {
      this.club_obj.club_parent[index].identify_manage_id = 0
      this.club_obj.club_parent[index].identify_date_date = ''
      this.club_obj.club_parent[index].identify_manage_label = ''
    },
    async set_parent_permission(index) {
      this.club_obj.club_parent[index].permission_manage_id =
        this.$store.state.auth.userId
      this.club_obj.club_parent[index].permission_date_date = common.getToday()
      this.club_obj.club_parent[index].permission_manage_label =
        this.$store.state.auth.label
    },
    async clear_parent_permission(index) {
      this.club_obj.club_parent[index].permission_manage_id = 0
      this.club_obj.club_parent[index].permission_date_date = ''
      this.club_obj.club_parent[index].permission_manage_label = ''
    },
    delPreferredData(target) {
      const tmps = { ...this.club_obj }
      if (
        typeof tmps.preferred_date_data === 'object' &&
        typeof tmps.preferred_date_data[target] === 'object'
      ) {
        tmps.preferred_date_data.splice(target, 1)
      }
      this.club_obj = tmps
    },
    addPreferredData() {
      const tmps = { ...this.club_obj }
      tmps.preferred_date_data.push(this.preferred_date_column)
      this.club_obj = tmps
    },
    delStaffRelation(target) {
      const tmps = { ...this.club_obj }
      if (
        typeof tmps.staff_relation_data === 'object' &&
        typeof tmps.staff_relation_data[target] === 'object'
      ) {
        tmps.staff_relation_data.splice(target, 1)
      }
      this.club_obj = tmps
    },
    addStaffRelation() {
      const tmps = { ...this.club_obj }
      tmps.staff_relation_data.push(this.staff_relation_column)
      this.club_obj = tmps
    },
    async loadMRelationObj() {
      const params = {}
      params['stat'] = [0, 1]
      params['c_id'] = this.targetid
      console.log('loadMRelationObj params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/club_m_relation/lists',
        params
      )
        .then(async response => {
          console.log('loadMRelationObj', response)
          this.m_relation_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_obj = []
        })
        .finally(async () => {
          // await this.setClubObj();
          this.$forceUpdate()
        })
    },
    async loadSexType() {
      // console.log('tag');
      return this.$store
        .dispatch('fetchBasicLists', { data: {}, target: 'sex_type' })
        .catch(err => Promise.reject(err))
        .then(response => {
          console.log('loadSexType', response)
        })
        .finally(() => {})
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventRelationObj() {
      const params = {}
      params['stat'] = [1]
      params['c_id'] = this.targetid
      console.log('loadEventRelationObj params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/club_event_relation/lists',
        params
      )
        .then(async response => {
          console.log('loadEventRelationObj', response)
          this.event_relation_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_relation_obj = []
        })
        .finally(async () => {
          // await this.setClubObj();
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseClassList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_class',
        params
      )
        .then(async response => {
          console.log('loadLicenseClassList response', response)
          this.license_class_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_class_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCategoryList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/license_category',
        params
      )
        .then(async response => {
          console.log('loadLicenseCategoryList response', response)
          this.license_category_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_category_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseCdObj', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadCircuitList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadClubObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/club/lists', params)
        .then(async response => {
          console.log('loadClubObj', response)
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}

          if (typeof tmp_obj === 'object') {
            tmp_obj.live_flg_now = tmp_obj.live_flg ? tmp_obj.live_flg : 'live'
            // this.club_error_obj = {...tmp_obj}.map(obj => {
            //   obj = (typeof obj === 'object')? []: false;
            //   return obj;
            // })
            const tmps = {}
            Object.keys(tmp_obj).forEach(tmp_key => {
              tmps[tmp_key] = typeof tmp_obj[tmp_key] === 'object' ? [] : false
            })
            this.club_error_obj = tmps

            this.oParam.forEach(param => {
              const param_key = param + '_column'
              if (
                typeof tmp_obj[param] !== 'object' ||
                tmp_obj[param] === false
              ) {
                tmp_obj[param] = []
              }
              if (
                // typeof tmp_obj[param] !== 'object'
                // ||
                typeof tmp_obj[param] === 'object' &&
                tmp_obj[param].length <= 0
              ) {
                // 保険
                // 所属クラブ
                // サーキットライセンス
                // システム設定
                // 対応メモ

                if (
                  [
                    'insurance_column',
                    'circuit_license_column',
                    'belong_club_column',
                    'system_exclude_column',
                    'club_note_column'
                  ].includes(param_key) === false
                )
                  tmp_obj[param].push({ ...this[param_key] })
                // this.club_error_obj[param].push({...this[param_key]}.map(obj => {
                //   obj = false;
                //   return obj;
                // }));
              } else if (param == 'profile') {
                const profile_tmp = tmp_obj[param].map(tmp => {
                  // tel_1 と tel_2 が既に文字列の場合は変更しない
                  if (typeof tmp.tel_1 === 'string') {
                    tmp.tel_1 = tmp.tel_1.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_1)) {
                    tmp.tel_1 = tmp.tel_1.join('-') // 配列の場合、文字列に変換
                  }

                  if (typeof tmp.tel_2 === 'string') {
                    tmp.tel_2 = tmp.tel_2.replace(/[^\d-]/g, '') // 数字とハイフン以外を削除
                  } else if (Array.isArray(tmp.tel_2)) {
                    tmp.tel_2 = tmp.tel_2.join('-') // 配列の場合、文字列に変換
                  }

                  return tmp
                })

                tmp_obj[param] = profile_tmp
              }
            })
          }
          // 上書き
          this.club_obj = tmp_obj
        })
        .catch(async err => {
          console.log(err)
          this.club_obj = {}
        })
        .finally(async () => {
          await this.loadEventRelationObj()
          await this.loadMRelationObj()
          this.$forceUpdate()
        })
    },
    async toggle_change_mode() {
      if (this.change_mode) {
        this.change_mode = false
      } else {
        this.change_mode = true
      }
    },
    async update_club() {
      const params = this.club_obj
      if (this.pass_chg_sw && this.pass_chg_confirm != this.login_pass_input) {
        alert('パスワードが一致しません')
        return true
      } else if (this.pass_chg_sw && this.pass_chg_confirm == '') {
        alert('パスワードを入力して下さい')
        return true
      } else if (
        this.pass_chg_sw &&
        this.pass_chg_confirm == this.login_pass_input
      ) {
        params.login_pass = this.login_pass_input
      }
      if (!this.pass_chg_sw) {
        delete params['login_pass']
      }

      const profs = (params || {}).profile
      if (typeof profs === 'object') {
        params.profile = profs.map(prof => {
          // tel_1 と tel_2 が既に文字列の場合は変更しない
          if (Array.isArray(prof.tel_1)) {
            prof.tel_1 = prof.tel_1.join('-')
          }
          if (Array.isArray(prof.tel_2)) {
            prof.tel_2 = prof.tel_2.join('-')
          }
          return prof
        })
      }
      const event_relation = this.event_relation_obj
      params.event_relation = event_relation
      const m_relation = this.m_relation_obj
      params.m_relation = m_relation
      await this.update(params)
    },
    async update(params) {
      console.log('component methods', this.club_obj)

      const post_url = this.not_add
        ? config.BASE_API_URL + '/club/edit/' + this.targetid
        : config.BASE_API_URL + '/club/add'

      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update club response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body[0].id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.club_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.club_error_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadClubObj()
          this.$forceUpdate()
          alert(this.alertMessage)
        })
    },
    back() {
      this.$router.go(-1)
    },
    tab_switch_action(tab) {
      this.tab_active = tab
    },
    async get_address(postal_cd, index) {
      const profile = this.club_obj.profile[index]
      await this.basicGets_O(
        'https://zipcloud.ibsnet.co.jp/api/search?zipcode=' + postal_cd
      )
        .then(res => {
          if (
            typeof res === 'object' &&
            typeof res.status === 'number' &&
            res.status == 200 &&
            typeof res.data === 'object' &&
            typeof res.data.results === 'object' &&
            typeof res.data.results[0] === 'object'
          ) {
            profile.pref_cd =
              parseInt(res.data.results[0].prefcode) < 10
                ? '0' + res.data.results[0].prefcode
                : res.data.results[0].prefcode
            profile.address_1 =
              res.data.results[0].address2 + res.data.results[0].address3
            profile.address_2 = ''
            this.club_obj.profile[index] = profile
          } else {
            alert('住所データがありません')
          }
        })
        .catch(error => {
          console.log(error)
          alert('住所データがありません.')
        })
        .finally(() => {
          this.$forceUpdate()
        })
    }
  },
  computed: {
    ...mapState({
      sex_type_list: state => state.apidata.sex_type
    }),
    get_last_event_year: function () {
      if (this.club_obj?.last_event_year) {
        return this.club_obj.last_event_year
      }
      return ''
    },
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    chk_parent_form: function () {
      if (
        this.calc_age <= 18 &&
        typeof this.club_obj === 'object' &&
        typeof this.club_obj.club_license === 'object'
        // && typeof this.club_obj.club_license.find()
      ) {
        return true
      }
      return false
    },
    input_class: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly: function () {
      if (this.change_mode) {
        return true
      } else {
        return false
      }
    },
    input_class_0: function () {
      if (this.change_mode_0) {
        return 'form-control-plaintext'
      } else {
        return 'form-control'
      }
    },
    input_readonly_0: function () {
      if (this.change_mode_0) {
        return true
      } else {
        return false
      }
    },
    input_class_f: function () {
      if (this.change_mode) {
        return 'form-control-plaintext'
      } else {
        return 'form-control-plaintext'
      }
    },
    input_readonly_f: function () {
      if (this.change_mode) {
        return true
      } else {
        return true
      }
    },
    event_class: function () {
      const relation = this.event_relation_obj
      const change_mode = this.change_mode
      return function (event_id) {
        if (relation.find(obj => obj.event_id == event_id)) {
          return change_mode
            ? 'text-center py-2 bg-warning rounded-2'
            : 'btn btn-warning'
        } else {
          return change_mode
            ? 'text-center py-2 bg-light rounded-2 border border-secondary'
            : 'btn btn-light btn-outline-secondary'
        }
      }
    },
    event_class_icon: function () {
      const relation = this.event_relation_obj
      return function (event_id) {
        if (relation.find(obj => obj.event_id == event_id)) {
          return 'bi bi-check-square'
        } else {
          return 'bi bi-square'
        }
      }
    },
    get_list_label: function () {
      return function (key, lists) {
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_pref_label: function () {
      const pref_list = this.pref_list
      return function (key) {
        if (typeof pref_list.find(pref => pref.key == key) === 'object') {
          return pref_list.find(pref => pref.key == key).label
        }
        return key
      }
    },
    get_request_cd_label: function () {
      const lists = this.request_type_list
      return function (key) {
        if (typeof lists.find(list => list.key == key) === 'object') {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    get_sex_type_label: function () {
      const sex_type_list = this.sex_type_list
      return function (key) {
        if (
          typeof sex_type_list.find(sex_type => sex_type.key == key) ===
          'object'
        ) {
          return sex_type_list.find(sex_type => sex_type.key == key).label
        }
        return key
      }
    },
    get_assets: function () {
      const club_obj = this.club_obj
      return function (type_cd, sort_key) {
        if (
          typeof club_obj === 'object' &&
          typeof club_obj.club_assets === 'object' &&
          club_obj.club_assets.find(asset => asset.type == type_cd) !== false &&
          typeof club_obj.club_assets.filter(asset => asset.type == type_cd) ===
            'object' &&
          typeof club_obj.club_assets.filter(asset => asset.type == type_cd)[
            sort_key
          ] === 'object'
        ) {
          return club_obj.club_assets.filter(asset => asset.type == type_cd)[
            sort_key
          ]
        }
        return {}
      }
    },
    chk_input_class: function () {
      const chk_func = this.chk_error
      return function (error_key, form) {
        if (form == 'input') {
          if (chk_func(error_key)) {
            return 'form-control is-invalid'
          } else {
            return 'form-control'
          }
        }
        return 'form-control'
      }
    },
    get_error: function () {
      const error_obj = this.club_error_obj
      return function (error_key) {
        const params =
          error_key.indexOf('.') > -1
            ? error_key.split('.')
            : [].concat(error_key)
        if (typeof error_obj === 'object' && typeof params === 'object') {
          if (
            params.length == 2 &&
            typeof error_obj[params[0]] === 'object' &&
            typeof error_obj[params[0]][params[1]] === 'string'
          ) {
            return error_obj[params[0]][params[1]]
          } else if (
            params.length == 1 &&
            typeof error_obj[params[0]] === 'string'
          ) {
            return error_obj[params[0]]
          }
        }
        return false
      }
    },
    chk_error: function () {
      const get_func = this.get_error
      return function (error_key) {
        if (get_func(error_key)) {
          return true
        }
        return false
      }
    },
    get_error_msg: function () {
      const chk_func = this.chk_error
      const get_func = this.get_error
      return function (error_key) {
        if (chk_func(error_key)) {
          return get_func(error_key)
        }
        return ''
      }
    },
    license_filter_sort: function () {
      const club_license = this.club_obj.club_license
      return function (license_class) {
        if (typeof club_license === 'object') {
          return club_license.filter(
            license =>
              parseInt(license.license_class) == parseInt(license_class)
          )
        }
        return false
      }
    },
    m_relation_list_year_list: function () {
      const year_list = []
      this.m_relation_obj.map(relation => {
        if (!year_list.find(year => year.key == relation.license_year)) {
          year_list.push({
            key: relation.license_year,
            label: relation.license_year + '年'
          })
        }
      })
      return year_list
    },
    m_relation_list_year: function () {
      if (this.member_sel_year != '') {
        return this.m_relation_obj.filter(
          relation => relation.license_year == this.member_sel_year
        )
      }
      return this.m_relation_obj
    },
    m_relation_list: function () {
      const m_relation_obj = []
      const tmps = [...this.m_relation_obj].sort((a, b) => {
        if (parseInt(a.license_year) > parseInt(b.license_year)) {
          return -1
        } else {
          return 1
        }
      })
      tmps.map(relation => {
        if (!m_relation_obj.find(obj => obj?.m_id == relation?.m_id)) {
          m_relation_obj.push(relation)
        } else if (
          m_relation_obj.find(
            obj =>
              obj?.m_id == relation?.m_id &&
              obj?.license_year < relation?.license_year
          )
        ) {
          const index = m_relation_obj.findIndex(
            obj =>
              obj?.m_id == relation?.m_id &&
              obj?.license_year < relation?.license_year
          )

          m_relation_obj.splice(index, 1)
          m_relation_obj.push(relation)
        }
      })
      return m_relation_obj
      // return m_relation_obj
      //   .sort((a, b) => {
      //     if (parseInt(a.sort) < parseInt(b.sort)) {
      //       return -1
      //     } else {
      //       return 1
      //     }
      //   })
      //   .map(rel => {
      //     // rel.stat_d = reltmp.stat;
      //     return rel
      //   })
      // return this.m_relation_obj;
    },

    get_club_license_filter_year: function () {
      const club_license = this.club_obj.club_license
      return function (year) {
        if (typeof club_license === 'object') {
          return club_license.filter(
            license => parseInt(license.license_year) == parseInt(year)
          )
        }
        return false
      }
    },
    get_club_license_filter_year_class: function () {
      const get_func = this.get_club_license_filter_year
      return function (year, class_cd) {
        const get_data = get_func(year)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_class) == parseInt(class_cd)
          )
        }
        return false
      }
    },
    chk_club_license_filter_year_class_only_term: function () {
      const get_func = this.get_club_license_filter_year_class
      const get_func2 = this.get_club_license_filter_year_class_term
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        const get_data2 = get_func2(year, class_cd, term_cd)
        if (
          typeof get_data === 'object' &&
          typeof get_data2 === 'object' &&
          get_data.length > 0 &&
          get_data2.length > 0 &&
          get_data.length == get_data2.length
        ) {
          return true
        }
        return false
      }
    },
    get_club_license_filter_year_class_term: function () {
      const get_func = this.get_club_license_filter_year_class
      return function (year, class_cd, term_cd) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(
            license => parseInt(license.license_term_cd) == parseInt(term_cd)
          )
        }
        return false
      }
    },
    get_club_license_filter_year_class_terms: function () {
      const get_func = this.get_club_license_filter_year_class
      return function (year, class_cd, term_cd_list) {
        const get_data = get_func(year, class_cd)
        if (typeof get_data === 'object') {
          return get_data.filter(license =>
            term_cd_list.includes(parseInt(license.license_term_cd))
          )
        }
        return false
      }
    },
    license_year_list: function () {
      const tmps = []
      for (let y = common.getNowYear() - 5; y <= common.getNowYear(); y++) {
        tmps.push({
          key: y,
          label: y + '年'
        })
      }

      return tmps.sort((a, b) => {
        if (parseInt(a.key) > parseInt(b.key)) {
          return -1
        } else {
          return 1
        }
      })
    },
    get_list_param: function () {
      const get_func_list = {
        event: this.get_event_data,
        license: this.get_license_data,
        license_class: this.get_class_data,
        license_category: this.get_category_data,
        affiliation_type: this.get_affiliation_type
      }
      return function (key, code, param) {
        const get_data = get_func_list[key](code)
        if (
          typeof get_data === 'object' &&
          (typeof get_data[param] === 'string' ||
            typeof get_data[param] === 'number')
        ) {
          return get_data[param]
        }
        return code
      }
    },
    get_affiliation_type: function () {
      const affiliation_type_list = this.affiliation_type_list
      return function (affiliation_cd) {
        return affiliation_type_list.find(
          affiliation => affiliation.key == affiliation_cd
        )
      }
    },
    get_event_data: function () {
      const event_cd_list = this.event_cd_list
      return function (event_cd) {
        return event_cd_list.find(event => event.event_cd == event_cd)
      }
    },
    get_license_data: function () {
      const license_cd_list = this.license_cd_list
      return function (license_cd) {
        return license_cd_list.find(license => license.license_cd == license_cd)
      }
    },
    get_class_data: function () {
      const class_list = this.license_class_list
      return function (class_cd) {
        return class_list.find(cls => cls.key == class_cd)
      }
    },
    get_category_data: function () {
      const category_list = this.license_category_list
      return function (category_cd) {
        return category_list.find(cate => cate.key == category_cd)
      }
    },
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return lists
        .map(list => {
          list.key = list.license_cd
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },

    pref_list: function () {
      const lists = [...this.pref_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    group_list: function () {
      return []
    },
    insurance_type_list: function () {
      const lists = [...this.insurance_type_obj]
      return lists
    },
    belong_club_status_list: function () {
      const lists = [...this.belong_club_status_obj]
      return lists
    },
    affiliation_type_list: function () {
      const lists = [...this.affiliation_type_obj]
      return lists
    },
    continue_app_type_list: function () {
      return this.continue_app_type_obj
    },
    continue_data_save_type_list: function () {
      return this.continue_data_save_type_obj
    },
    request_type_list: function () {
      return this.request_type_cd_obj
    },
    identify_type_list: function () {
      return this.identify_type_cd_obj
    },
    exclude_list: function () {
      return this.exclude_cd_obj
    },
    dead_or_live_list: function () {
      return this.dead_or_live_obj
    },
    club_assets_list: function () {
      return this.club_assets_cd_obj
    },
    club_document_list: function () {
      return this.club_document_cd_obj
    },

    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    tabDisplay: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'd-none '
        if (self_tab_active == tab) {
          tabClass = 'd-block'
        }
        return tabClass
      }
    },
    tab_switch: function () {
      const self_tab_active = this.tab_active
      return function (tab) {
        let tabClass = 'nav-link '
        // console.log('tab_switch', self_tab_active);
        if (self_tab_active == tab) {
          tabClass += 'active'
        }
        return tabClass
      }
    },
    circuit_list: function () {
      const lists = [...this.circuit_obj]
      return lists
        .map(list => {
          list.key = list.id
          // list.class_label = this.get_list_param('license_class', list.license_class, 'label');
          // list.category_label = this.get_category_label('license_category', list.license_category, 'label');
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    get_clinic_data: function () {
      const clinic_list = this.clinic_list
      return function (clinic_id) {
        return clinic_list.find(clinic => {
          return clinic.id == clinic_id
        })
      }
    },
    get_clinic_label: function () {
      const get_clinic_data = this.get_clinic_data
      return function (clinic_id) {
        return get_clinic_data(clinic_id).label
      }
    }
  },

  async created() {
    await this.loadLicenseCdList()
    await this.loadEventCdList()
    await this.loadLicenseClassList()
    await this.loadLicenseCategoryList()
    await this.loadLicenseTypeObj()
    await this.loadPrefList()
    await this.loadSexType()
    await this.loadCircuitList()
    await this.loadConfigObj('affiliation_type')
    await this.loadConfigObj('insurance_type')
    await this.loadConfigObj('belong_club_status')
    await this.loadConfigObj('continue_app_type')
    await this.loadConfigObj('continue_data_save_type')
    await this.loadConfigObj('request_type_cd')
    await this.loadConfigObj('identify_type_cd')
    await this.loadConfigObj('exclude_cd')
    await this.loadConfigObj('dead_or_live')
    await this.loadConfigObj('club_assets_cd')
    await this.loadConfigObj('club_document_cd')
    await this.loadConfigObj('license_term_cd')

    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      await this.loadClubObj()
      this.btnLabel = '更新'
    } else {
      this.club_obj = Object.assign({
        id: 0,
        stat: 1,
        name_1: '',
        name_2: '',
        name_3: '',
        yomi_1: '',
        yomi_2: '',
        yomi_3: '',
        line_name_1: '',
        line_name_2: '',
        login_id: '',
        birth_date: '',
        sex_type: 'unanswered',
        license_no: '',
        live_flg: 'live',
        live_flg_now: 'live',
        identify_type: '',
        identify_manage_id: '',
        identify_date: '',
        continue_app_type: 0,
        continue_data_save_type: 0,
        application_date: '',
        permission_date: '',
        permission_manage_id: '',
        payment_date: '',
        identify_sw: false,
        identify_manage_label: '',
        permission_sw: false,
        permission_manage_label: '',
        identify_date_date: '',
        application_date_date: '',
        permission_date_date: '',
        payment_date_date: '',
        profile: [],
        insurance: [],
        circuit_license: [],
        belong_club: [],
        system_exclude: [],
        club_parent: [],
        club_note: [],
        club_assets: [],
        club_license: []
      })
      this.btnLabel = '登録'

      // set
      // this.club_obj.profile.push({...this.profile_column});
      // this.club_obj.insurance.push({...this.insurance_column});
      this.oParam.forEach(param => {
        const param_key = param + '_column'
        if (this.club_obj[param] === false) {
          this.club_obj[param] = []
          this.club_error_obj[param] = []
        }
        if (
          typeof this.club_obj[param] !== 'object' ||
          (typeof this.club_obj[param] === 'object' &&
            this.club_obj[param].length <= 0)
        ) {
          this.club_obj[param].push({ ...this[param_key] })
        }
      })
    }
    this.alertMessage = this.btnLabel + 'できます'
    if (!this.not_add) {
      this.change_mode = false
    }
    this.$forceUpdate()
  },
  mounted: function () {
    this.fromParentTitle = '公認クラブデータ'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
